<template>
    <div class="main-header">
        <div class="icon-text-header">
            <div class="icon-div">
                <svg xmlns="http://www.w3.org/2000/svg" width="380" height="380" viewBox="0 0 480 480" fill="none" class="pattern" opacity="0.4">
                    <defs>
                        <clipPath id="clip-circle">
                            <rect x="190" y="190" width="240" height="240" />
                        </clipPath>
                    </defs>
                    <g clip-path="url(#clip-circle)">
                        <circle cx="240" cy="240" r="60" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="92" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="124" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="156" stroke="#E4E4E7" />
                    </g>
                </svg>
                <user-plus />
            </div>
            <div>
                <div class="title-section">
                    <p>Edit Contact</p>
                </div>
                <p class="sub-title-div">Update contact information</p>
            </div>
            <!-- <div class="close-icon ml-auto" @click="$emit('closeDialog')">
                <XMarkIcon class="w-6 h-6 text-gray-500" />
            </div> -->
        </div>
    </div>
</template>

<script setup lang="ts">
// import { XMarkIcon } from '@heroicons/vue/24/outline';
import UserPlus from '~/assets/images/icons/user-plus.svg';

defineEmits(['closeDialog']);
</script>

<style lang="scss" scoped>
.main-header {
    @apply flex sm:flex-row flex-col p-6 pt-6 pb-0 px-6 items-start gap-4 self-stretch pb-5;
}
.icon-div {
    @apply relative flex w-12 h-12 p-3 justify-center items-center rounded-lg border border-gray-200 bg-white shadow-cardshadow;
}
.icon-text-header{
    @apply flex flex-row items-start gap-4 items-start w-full ;
}
.title-wrapper {
    @apply flex flex-col items-start gap-1 sm:flex-1 sm:w-auto w-full sm:pl-16;
}
.title-section {
    @apply self-stretch flex flex-row justify-between relative;

    p {
        @apply text-zinc-950 font-inter text-lg font-semibold leading-7;
    }
}
.close-icon {
    @apply flex justify-center items-center rounded-lg text-gray-400 cursor-pointer;
}
.sub-title-div {
    @apply text-zinc-600 font-inter text-sm font-normal leading-5;
}
.pattern {
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
}

</style>
